module.exports = __webpack_public_path__ + "static/guide-left-img.a01e8d05.png";